import { Navigate } from "react-router-dom";

import {
  ApiReportReportStatusChoices,
  AssessmentToolType,
  ReportTypeEnums,
  useAssessmentToolsQuery,
} from "@api/graphql/types-and-hooks";
import { EvaluationSubRoute } from "@pages/EvaluationDetails/EvaluationDetails";
import { ReportNode, useReport } from "@providers/ReportProvider";
import { getNumberOfPagesDone } from "@routes/Evaluations/Evaluations";

const getProperEvaluationRedirectPathFromReport = (
  evaluation: ReportNode,
  supportedAssessmentsList: AssessmentToolType[],
): EvaluationSubRoute => {
  if (!evaluation) return "client-details";

  const reportIsCompleted = evaluation?.reportStatus === ApiReportReportStatusChoices.Completed;
  const reportHasClient = !!evaluation?.learner?.id;
  const pagesDone = getNumberOfPagesDone(evaluation, supportedAssessmentsList);

  switch (true) {
    case reportIsCompleted:
      return `review-and-sign`;
    case pagesDone === 3:
      return `report-part-1`;
    case pagesDone === 4:
      return `report-part-2`;
    case pagesDone === 5:
      return `conclusions`;
    case pagesDone === 6:
      return `recommendations`;
    case reportHasClient:
      return `upload-files`;
    default:
      return `client-details`;
  }
};

export const EvaluationDetailsRedirect = () => {
  const { report } = useReport();
  const response = useAssessmentToolsQuery({ reportType: ReportTypeEnums.DiagnosisEvaluation });
  const supportedAssessmentsList: AssessmentToolType[] =
    response.data?.assessmentTools?.filter((item) => !!item).filter((tool) => tool.parsingSupported) ?? [];

  const pathToRedirectTo = getProperEvaluationRedirectPathFromReport(report, supportedAssessmentsList);

  return <Navigate to={pathToRedirectTo} replace />;
};
